<template>
	<div class="cooperation-data-tab">
		<div class="filter" v-if="isAllDataView">
			<div class="label">跟进人</div>
			<el-select size="mini" v-model="user_id" placeholder="请选择" @change="getInfo" clearable>
				<el-option :label="item.partner_role_name" :value="item.user_id" v-for="(item, index) in partners" :key="index" />
			</el-select>
		</div>
		<data-card title="合作数据" ref="cooperationRef" :list="cooperationList" @submit="getPartnerData"></data-card>
		<data-card class="mt-12" title="成交数据" ref="makeRef" :list="makeList" @submit="getMakeData"></data-card>
		<data-card title="待办数据" :list="awaitList" @submit="getWaitData" class="mt-12" :show-select="false" />
		<div class="table-wrap">
			<div class="label">跟进记录</div>
			<el-table :data="followList" header-row-class-name="table-header-row" row-class-name="table-row">
				<el-table-column prop="add_time" label="时间" width="250"></el-table-column>
				<el-table-column prop="action_type" label="操作" width="180"></el-table-column>
				<el-table-column label="操作内容">
					<template v-slot="{ row: { action_content } }">
						<div>
							<span>{{ action_content.content }}</span>
							<span v-if="action_content.jump_name">
								<span>-</span>
								<span class="table-btn" @click="goToUrl(action_content.jump_url)">{{ action_content.jump_name }}</span>
							</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="operator_name" label="操作人" width="250"></el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import dataCard from '../dataCard';
import { getPartnerData, getMakeData, getWaitData, getFollowList } from '@/api/talentCRM';

export default {
	name: 'cooperationDataTab',
	props: {
		anchorId: {
			type: [String, Number],
			default: '',
		},
		partners: {
			type: Array,
			default: _ => [],
		},
	},
	components: {
		dataCard,
	},
	computed: {
		...mapGetters(['isAllDataView']),
	},
	data() {
		return {
			cooperationList: [
				{ label: '推品数', desc: '为达人推荐分享的商品总数', number: 0 },
				{ label: '选品数', desc: '达人加入选品表的商品总数', number: 0 },
				// { label: '申样数', desc: '达人申请样品的商品总数', number: 0 },
				{ label: '寄样数', desc: '为达人寄样的商品总数', number: 0 },
				{ label: '开播数', desc: '达人确认开播的商品总数', number: 0 },
			],
			makeList: [
				{ label: '销售额', desc: '与达人合作的订单销售额累计', number: 0 },
				{ label: '销量', desc: '与达人合作的订单销量累计', number: 0 },
				// { label: '商品数', desc: '与达人合作的商品数量', number: 0 },
			],
			awaitList: [
				{ label: '待寄样数', desc: '已申样，未发货的商品数', number: 0 },
				{ label: '待收货数', desc: '已寄样，未收货的商品数', number: 0 },
				{ label: '待排期数', desc: '已收货，待确认排期的商品数', number: 0 },
				{ label: '待开播数', desc: '已排期，待确认开播的商品数', number: 0 },
			],
			followList: [],
			start_time: 0,
			end_time: 0,
			user_id: '',
		};
	},
	methods: {
		getInfo() {
			!this.isAllDataView && (this.user_id = this.partners[0]?.user_id || '');
			this.getFollowList();
			const { start_time, end_time } = this.$refs.cooperationRef.reset(4, 30);
			this.start_time = start_time;
			this.end_time = end_time;
			this.$refs.makeRef.reset(4, 30);
			this.getMakeData();
			this.getPartnerData();
			this.getWaitData();
		},
		setPartnerId(user_id = '') {
			this.user_id = user_id;
		},
		reset() {
			this.cooperationList.forEach(item => (item.number = 0));
			this.awaitList.forEach(item => (item.number = 0));
			this.followList = [];
			this.user_id = '';
		},
		async getPartnerData(params) {
			if (!params) {
				const { start_time, end_time } = this;
				params = { start_time, end_time };
			}
			const { user_id } = this;
			params = { ...params, anchor_id: this.anchorId, user_id };
			const {
				code,
				data: { share_num, select_num, send_num, play_num },
			} = await getPartnerData(params);
			if (code !== 0) return;
			[share_num, select_num, send_num, play_num].forEach((item, index) => (this.cooperationList[index].number = item));
		},
		async getMakeData(params) {
			if (!params) {
				const { start_time, end_time } = this;
				params = { start_time, end_time };
			}
			const { user_id } = this;
			params = { ...params, anchor_id: this.anchorId, user_id };
			const {
				code,
				data: { sale_amount, sale_count },
			} = await getMakeData(params);
			if (code !== 0) return;
			[sale_amount, sale_count].forEach((item, index) => (this.makeList[index].number = item));
		},
		async getWaitData() {
			const { user_id } = this;
			const {
				code,
				data: { wait_send_num, wait_receive_num, wait_plan_num, wait_live_num },
			} = await getWaitData({ anchor_id: this.anchorId, user_id });
			if (code !== 0) return;
			[wait_send_num, wait_receive_num, wait_plan_num, wait_live_num].forEach((item, index) => (this.awaitList[index].number = item));
		},
		async getFollowList() {
			const { user_id } = this;
			const { code, data: { list = [] } = {} } = await getFollowList({ anchor_id: this.anchorId, user_id });
			if (code !== 0) return;
			this.followList = list;
		},
		goToUrl(path) {
			const { href } = this.$router.resolve({ path });
			window.open(href, '_blank');
		},
	},
};
</script>

<style lang="less" scoped>
.cooperation-data-tab {
	padding-left: 12px;
	padding-right: 28px;
	.filter {
		display: flex;
		align-items: center;
		padding: 10px 0 20px;
		border-bottom: 1px solid #eee;
		margin-bottom: 20px;
		.label {
			margin-right: 12px;
			color: #333;
			font-size: 14px;
		}
	}
	.look {
		font-size: 16px;
		color: #333;
		cursor: pointer;
		border-bottom: 1px solid #333;
		display: flex;
		align-items: baseline;
	}
	.table-wrap {
		padding: 16px 0;
		.label {
			font-size: 16px;
			color: #333;
			font-weight: bold;
			margin-bottom: 16px;
		}
		.table-btn {
			cursor: pointer;
			color: #1890ff;
		}
	}
}
</style>
